import { apiClient } from '../../api/client';
import { ApiResponse, PagedResponse } from '../../api/types';
import { PaySegment, RecalculatePaySegmentRequest, RecalculatedPaySegment, ServerTime } from './types';

export async function listPaySegments(page: number, perPage: number, userID?: string): Promise<PagedResponse<PaySegment>> {
  const response = await apiClient.get<PagedResponse<PaySegment>>('/api/v1/admin/pay-segments', {
    params: { page, per_page: perPage, ...(userID ? { user_id: userID } : {}) },
  });
  return response.data;
}

export async function getServerTime(): Promise<ServerTime> {
  const response = await apiClient.get<ApiResponse<ServerTime>>('/api/v1/admin/server-time');
  return response.data.data;
}

export async function setServerTime(time: string | null): Promise<ServerTime> {
  const response = await apiClient.put<ApiResponse<ServerTime>>('/api/v1/admin/server-time', { time });
  return response.data.data;
}

export async function recalculatePaySegment(input: RecalculatePaySegmentRequest): Promise<RecalculatedPaySegment> {
  const response = await apiClient.post<ApiResponse<RecalculatedPaySegment>>('/api/v1/admin/pay-segments/recalculate', input);
  return response.data.data;
}
